"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCarline = void 0;
const applyCarlineStrategies_1 = require("./strategies/carlineStrategies/applyCarlineStrategies");
const transformCarline = (carline, locale, i18nlanguage) => (0, applyCarlineStrategies_1.applyCarlineStrategies)(carline, locale, i18nlanguage);
exports.transformCarline = transformCarline;
